import tracking from "@irati-tracking/tracker"
import authentication from "@irati/auth"
import {Location} from "history"

// we don't import tracking in history as it has a side-effect of setting up observers that break in test
import history from "./index"

/**
 * Listen to history events from our custom history wrapper and push changes to mixpanel
 *
 * the tracking is debounced to wait on page redirects
 */
export function setupTrackUrl() {
  // track the initial page load
  const url = getUrl(history.location)
  trackUrl(history.location, url)

  history.listen(debounce(trackUrl, 1000))
}

function trackUrl(location: Location<any>, prevUrl?: URL) {
  // only track logged in users
  if (!authentication.isLoggedIn()) return

  if (prevUrl?.search === location.search && prevUrl.pathname === location.pathname) return

  tracking.trackUrl({
    previous: prevUrl
      ? {
          search: prevUrl.search,
          path: prevUrl.pathname
        }
      : undefined,
    current: {
      path: location.pathname,
      search: location.search
    }
  })
}

function debounce(callback: typeof trackUrl, wait: number) {
  let timeoutId: any = null
  // the original url when the first navigation happened
  // this way if the page has several deep redirects /foo -> /foo/bar -> /foo/bar?bing=nope
  // then we only track the start and end /foo -> /foo/bar?bing=nope
  let url: URL | undefined = undefined
  let started = false

  return (location: Location<any>) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    if (!started) {
      url = getUrl(location)
      started = true
    }

    timeoutId = setTimeout(() => {
      callback(location, url)
      url = undefined
      started = false
    }, wait)
  }
}

function getUrl(location: Location<any>) {
  const prev = location?.state?.prevUrl ?? ""
  let url
  if (prev) {
    url = new URL(prev)
  }
  return url
}
